import { __assign, __awaiter, __generator } from "tslib";
import { createClient } from '@wix/sdk/client';
import { checkout as ecomCheckout } from '@wix/ecom';
import { getApiBaseUrl } from '../../utils/getWixApiBaseUrl';
import { getCurrencyHeader, getMultiLangHeader } from '../../utils/headers';
import { mapToLineItem } from './addToCurrentCart/mapToLineItem';
var CheckoutService = /** @class */ (function () {
    function CheckoutService(context) {
        this.context = context;
    }
    CheckoutService.prototype.createCheckout = function (productId, quantity, options, preOrderRequested) {
        return __awaiter(this, void 0, void 0, function () {
            var lineItem, wixClient;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mapToLineItem({
                            productId: productId.toString(),
                            quantity: Number(quantity),
                            preOrderRequested: preOrderRequested,
                            options: options !== null && options !== void 0 ? options : {},
                        }, this.context)];
                    case 1:
                        lineItem = _a.sent();
                        wixClient = createClient({
                            auth: {
                                getAuthHeaders: function () {
                                    var currencyHeader = getCurrencyHeader(_this.context.wixAPI);
                                    var multiLangHeader = getMultiLangHeader(_this.context.wixAPI, _this.context.initParams.instance);
                                    return {
                                        headers: __assign(__assign({ Authorization: _this.context.initParams.instance }, (currencyHeader ? { 'x-wixstores-currency': currencyHeader } : {})), (multiLangHeader ? { 'x-wix-multilingual': multiLangHeader } : {})),
                                    };
                                },
                            },
                            modules: {
                                checkout: {
                                    createCheckout: ecomCheckout.createCheckout,
                                },
                            },
                            host: {
                                apiBaseUrl: getApiBaseUrl(this.context.wixAPI.window.rendering.env === 'backend', this.context.initParams.url),
                            },
                        });
                        return [2 /*return*/, wixClient.checkout.createCheckout({
                                channelType: ecomCheckout.ChannelType.WEB,
                                lineItems: [lineItem],
                            })];
                }
            });
        });
    };
    return CheckoutService;
}());
export { CheckoutService };
//# sourceMappingURL=CheckoutService.js.map